/* Cross-tab auth notifications. */

export const AUTH_CHANNEL = "trevex-auth";
export const AUTH_FALLBACK_KEY = "trevex-auth-tick";

export const AUTH_EVENTS = {
  SIGNED_IN: "signed-in",
  SIGNED_OUT: "signed-out",
  REFRESHED: "refreshed",
};

let channel = null;

const getChannel = () => {
  if (channel !== null) return channel;
  try {
    channel = typeof BroadcastChannel !== "undefined"
      ? new BroadcastChannel(AUTH_CHANNEL)
      : false;
  } catch {
    channel = false;
  }
  return channel;
};

/* Tell the other tabs something happened. */
export const postAuthEvent = (type, identity = null) => {
  const message = { type, identity: identity ?? null, at: Date.now() };

  const bc = getChannel();
  if (bc) {
    try {
      bc.postMessage(message);
    } catch {
      // A closed channel must never break the action that triggered it.
    }
  }

  try {
    // Written unconditionally: BroadcastChannel does not fire in the tab that
    // posted, and neither does `storage`, so this is a safe belt-and-braces
    // for browsers where the channel silently no-ops.
    localStorage.setItem(AUTH_FALLBACK_KEY, JSON.stringify(message));
  } catch {
    // Private mode, or storage disabled.
  }
};

/**
 * Subscribe to auth events from OTHER tabs. Returns an unsubscribe function.
 */
export const subscribeToAuthEvents = (handler) => {
  const onMessage = (event) => {
    const data = event?.data;
    if (data && typeof data.type === "string") handler(data);
  };

  const onStorage = (event) => {
    if (event.key !== AUTH_FALLBACK_KEY || !event.newValue) return;
    try {
      const data = JSON.parse(event.newValue);
      if (data && typeof data.type === "string") handler(data);
    } catch {
      // Ignore a malformed value written by anything else.
    }
  };

  const bc = getChannel();
  if (bc) bc.addEventListener("message", onMessage);
  window.addEventListener("storage", onStorage);

  return () => {
    if (bc) bc.removeEventListener("message", onMessage);
    window.removeEventListener("storage", onStorage);
  };
};

/** Test seam — drops the memoised channel so a fresh one is built. */
export const __resetAuthChannel = () => {
  if (channel) {
    try {
      channel.close();
    } catch {
      /* already closed */
    }
  }
  channel = null;
};
